/*
  Notify-when-back-in-stock inline form.

  Subscribes to trautis:variant-change (from Phase 2a's
  product-variant-reactivity-trautis.js, detail.variant payload).
  On variant flip, mutually toggles the `hidden` attribute on the
  [data-atc-button] and [data-notify-oos] elements based on
  variant.available. Also rewrites the hidden form inputs so the
  submitted email reflects the user's selection.

  Submission is a native {% form 'contact' %} POST — Shopify rejects
  programmatic fetch POSTs to /contact with HTTP 400 "Missing CAPTCHA
  token", so AJAX is not possible. To avoid the post-redirect scroll jump
  (Shopify lands on …?contact_posted=true) we remember the scroll position
  before submit and restore it after the reload, then clean the URL. The
  success message itself is rendered server-side (form.posted_successfully?).

  No innerHTML writes — only setAttribute / removeAttribute.
*/

(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.TrautisNotifyOOS = api;
    if (root.document && root.document.addEventListener) {
      if (root.document.readyState === 'loading') {
        root.document.addEventListener('DOMContentLoaded', api.init);
      } else {
        api.init();
      }
    }
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var SCROLL_KEY = 't-notify-scroll';

  // Global handle (factory scope has no `root`).
  var glob = typeof globalThis !== 'undefined'
    ? globalThis
    : (typeof window !== 'undefined' ? window : {});

  function bindSection(sectionRoot) {
    var notify = sectionRoot.querySelector('[data-notify-oos]');
    var atc = sectionRoot.querySelector('[data-atc-button]');
    if (!notify || !atc) return;

    sectionRoot.addEventListener('trautis:variant-change', function (ev) {
      var v = ev && ev.detail && ev.detail.variant;
      if (!v) return;

      if (v.available) {
        notify.setAttribute('hidden', '');
        atc.removeAttribute('hidden');
        return;
      }

      // OOS path: show form, hide ATC, rewrite hidden inputs
      notify.removeAttribute('hidden');
      atc.setAttribute('hidden', '');

      var skuInput = notify.querySelector('[data-notify-variant-sku]');
      if (skuInput) skuInput.setAttribute('value', v.sku || '');

      var urlInput = notify.querySelector('[data-notify-variant-url]');
      if (urlInput) {
        var cur = urlInput.getAttribute('value') || '';
        var base = cur.split('?variant=')[0];
        urlInput.setAttribute('value', base + '?variant=' + (v.id || ''));
      }
    });

    bindScrollPreserve(notify);
  }

  // The contact form submits natively (Shopify CAPTCHA blocks fetch). Remember
  // where the user was so handlePostSubmit() can restore it after the reload.
  function bindScrollPreserve(notify) {
    var form = notify.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', function () {
      try {
        glob.sessionStorage.setItem(SCROLL_KEY, String(glob.scrollY || glob.pageYOffset || 0));
      } catch (e) { /* sessionStorage unavailable */ }
    });
  }

  // After the post-redirect (…?contact_posted=true), restore the saved scroll
  // position and strip contact_posted from the URL so a refresh doesn't re-show
  // the confirmation. The success message is rendered server-side.
  function handlePostSubmit() {
    var loc = glob.location;
    if (!loc || !/[?&]contact_posted=true/.test(loc.search || '')) return;

    try {
      var y = glob.sessionStorage.getItem(SCROLL_KEY);
      if (y !== null && y !== undefined) {
        glob.scrollTo(0, parseInt(y, 10) || 0);
        glob.sessionStorage.removeItem(SCROLL_KEY);
      }
    } catch (e) { /* sessionStorage unavailable */ }

    try {
      if (glob.history && glob.history.replaceState) {
        var search = (loc.search || '')
          .replace(/([?&])contact_posted=true&?/, '$1')
          .replace(/[?&]$/, '');
        glob.history.replaceState(null, '', loc.pathname + search);
      }
    } catch (e) { /* history unavailable */ }
  }

  function init() {
    var sections = document.querySelectorAll('[data-product-section]');
    for (var i = 0; i < sections.length; i++) {
      bindSection(sections[i]);
    }
    handlePostSubmit();
  }

  return {
    init: init,
    bindSection: bindSection,
    handlePostSubmit: handlePostSubmit,
  };
});
